import { Leaderboard } from "@/components/engage/Leaderboard";
import { ModeCard } from "@/components/engage/ModeCard";

export default function LeaderboardPage() {
  return (
    <div className="space-y-5 max-w-3xl" data-testid="leaderboard-page">
      <div><h1 className="font-head font-extrabold text-4xl">Leaderboard</h1>
        <p className="text-sm text-slate-400 mt-1">The top practice traders this week. Finish practice bets to climb, build streaks and unlock higher modes.</p></div>
      <ModeCard />
      <Leaderboard />
    </div>
  );
}
